import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=2cd7a1c6&scoped=true"
import script from "./Package.vue?vue&type=script&lang=ts"
export * from "./Package.vue?vue&type=script&lang=ts"
import style0 from "./Package.vue?vue&type=style&index=0&id=2cd7a1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd7a1c6",
  null
  
)

export default component.exports